import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Map.scss';

/**
 * @description Map component displays google map
 *
 * @param {object} props - Component props
 * @param {function} props.loadMap - Method to invoke when the map is ready to load
 * @param {boolean} props.loaded - Lets this component know that the Google API is ready
 *
 * @returns {<Map />}
 */
class Map extends Component {
  componentDidMount() {
    this.props.loadMap(this.map);
  }

  componentDidUpdate(prevProps) {
    const { loaded, zoom } = this.props;

    if (prevProps.loaded !== loaded && zoom !== 0) {
      this.props.loadMap(this.map);
    }
  }

  render() {
    const mapRef = el => {
      this.map = el;
    };

    return <div className="map" ref={mapRef} />;
  }
}

Map.propTypes = {
  loaded: PropTypes.bool,
  loadMap: PropTypes.func,
  zoom: PropTypes.number,
};

Map.defaultProps = {
  loaded: false,
  loadMap: null,
  zoom: 11,
};

export default Map;
